import { ApiQuery, ApiResponse } from "@/@types";
import { Endpoints, Http, HttpService } from "@/infra/api";
import {
  GeneralInfo,
  GeneralInfoResponse,
  MonitoringInfo,
  MonitoringInfoResponse,
} from "@/domain/models";

type HomeRepository = {
  getGerenalInfo: (query?: ApiQuery) => Promise<ApiResponse<GeneralInfo>>;
  getMonitoringInfo: (query?: ApiQuery) => Promise<ApiResponse<MonitoringInfo>>;
};

export const HomeService = (http: Http = HttpService()): HomeRepository => ({
  getGerenalInfo: async (query) => {
    const res = await http.get<GeneralInfoResponse>(
      Endpoints.home_general,
      query
    );
    const data = new GeneralInfo(res.data);
    return { ...res, data };
  },
  getMonitoringInfo: async (query) => {
    const res = await http.get<MonitoringInfoResponse>(
      Endpoints.home_monitoring,
      query
    );
    const data = new MonitoringInfo(res.data);
    return { ...res, data };
  },
});
